(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hifi-billing-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hifi-billing-fields')) {
    let billingState;
    let saveQueue = Promise.resolve();
    let saveTimer;
    const names = ['billing_documento', 'billing_rut', 'billing_rzn_social', 'billing_giro'];

    class HifiBillingFields extends HTMLElement {
      connectedCallback() {
        this.fields = Object.fromEntries(names.map(name => [name, this.querySelector(`[name="attributes[${name}]"]`)]));
        this.form = this.fields.billing_documento.form;
        this.error = this.querySelector('[data-billing-error]');
        this.onEdit = event => {
          event.stopPropagation();
          billingState = this.read();
          document.querySelectorAll('hifi-billing-fields').forEach(element => element.sync());
          clearTimeout(saveTimer);
          saveTimer = setTimeout(() => this.save().catch(() => this.showError()), 300);
        };
        this.onSubmit = async event => {
          if (this.submitting) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          billingState = this.read();
          this.sync();
          if (!this.form.reportValidity()) return;
          const submitter = event.submitter;
          clearTimeout(saveTimer);
          this.error.hidden = true;
          try {
            await this.save();
            this.submitting = true;
            this.form.requestSubmit(submitter || undefined);
          } catch {
            this.showError();
          } finally {
            this.submitting = false;
          }
        };
        this.addEventListener('input', this.onEdit);
        this.addEventListener('change', this.onEdit);
        this.form?.addEventListener('submit', this.onSubmit, true);
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('input', this.onEdit);
        this.removeEventListener('change', this.onEdit);
        this.form?.removeEventListener('submit', this.onSubmit, true);
      }

      read() {
        const result = Object.fromEntries(names.map(name => [name, this.fields[name].value.trim()]));
        if (result.billing_documento !== '33') {
          names.slice(1).forEach(name => { result[name] = ''; });
        }
        return result;
      }

      sync() {
        if (billingState) names.forEach(name => { this.fields[name].value = billingState[name]; });
        const invoice = this.fields.billing_documento.value === '33';
        this.querySelector('[data-invoice-fields]').hidden = !invoice;
        names.slice(1).forEach(name => { this.fields[name].required = invoice; });
        const rut = this.fields.billing_rut;
        const clean = rut.value.replace(/[.\s-]/g, '').toUpperCase();
        let valid = /^[1-9]\d{6,7}[\dK]$/.test(clean);
        if (valid) {
          let sum = 0;
          let factor = 2;
          for (let index = clean.length - 2; index >= 0; index--) {
            sum += Number(clean[index]) * factor;
            factor = factor === 7 ? 2 : factor + 1;
          }
          const digit = 11 - sum % 11;
          valid = clean.at(-1) === (digit === 11 ? '0' : digit === 10 ? 'K' : String(digit));
        }
        rut.setCustomValidity(invoice && rut.value && !valid ? this.dataset.rutError : '');
        this.error.hidden = true;
      }

      save() {
        const attributes = { ...(billingState || this.read()) };
        const request = saveQueue.catch(() => {}).then(async () => {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) throw new Error('billing-save');
          const cart = await response.json();
          if (names.some(name => (cart.attributes[name] || '') !== attributes[name])) throw new Error('billing-save');
        });
        saveQueue = request;
        return request;
      }

      showError() {
        this.error.textContent = this.dataset.saveError;
        this.error.hidden = false;
      }
    }
    customElements.define('hifi-billing-fields', HifiBillingFields);
  }
  } catch(e) { console.error(e); }
})();

})();
